import React, {useEffect, useState} from 'react';
import "./CreateProductType.css"
import Scrollbar from "react-scrollbars-custom";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import {strings} from "../../../strings";
import axios from "axios";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import {SnackbarProvider} from "notistack";
import {useDispatch, useSelector} from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {LoadingComponents} from "../../module";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Dialog from "@mui/material/Dialog";
import {notification} from "../../functions/notification/notificationFunction";
import {selToken} from "../../../stores/base/baseSlice";


const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

function CreateProductType() {
    const [allAttributes, setAllAttributes] = useState(null);
    const [productName, setProductName] = useState("");
    const [title, setTitle] = useState("");
    const [allAttributesSelected, setAllAttributesSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allProductType, setAllProductType] = useState(null);
    const [dialogForEdit, setDialogForEdit] = useState(false);
    const [dialogForCreate, setDialogForCreate] = useState(false);

    const token = useSelector(selToken);

    const dispatch = useDispatch();


    async function getAllAttribute() {
        await axios.get(strings.baseUrl + `attribute`)
            .then(result => {
                if (result.data.status_code === 200) {
                    setAllAttributes(result.data.data.attributes)
                }else if(result.data.status_code === 401){
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                dispatch(notification("error", "خوش آمدید", <h3>خطایی رخ داد</h3>, false))
            })
    }

    async function getAllProductType() {
        setLoading(true);
        await axios.get(strings.baseUrl + `product-type`)
            .then(result => {
                if (result.data.status_code === 200) {
                    setAllProductType(result.data.data.product_types)
                }else if(result.data.status_code === 401){
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                dispatch(notification("error", "خوش آمدید", <h3>خطایی رخ داد</h3>, false))
            });
        setLoading(false);
    }


    async function addProductType() {
        const formData = new FormData();
        const dataTable = {
            name: productName,
            title: title,
            attribute_ids: allAttributesSelected
        };
        for (let keyName in dataTable) {
            if (keyName === "attribute_ids") {
                dataTable[keyName].map((x, i) => (
                    formData.append(`attribute_ids[${i}]`, x.id)
                ))
            } else formData.append(keyName, dataTable[keyName]);
        }
        await axios({
            method: "post",
            url: strings.baseUrl + `product-type`,
            data: formData,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(result => {
                if (result.data.status_code === 200) {
                    dispatch(notification("success", "خوش آمدید", <h3>با موفقیت درج شد</h3>, false))
                    getAllProductType();
                    setDialogForCreate(false);
                }else if(result.data.status_code === 401){
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    function TrTable(props) {
        const [select, setSelect] = useState(false);
        const {data, number} = props
        return (
            <tr className={`${select ? "selectedTr" : ""}`}>
                <td>
                    <i className="fas fa-info-circle"/>
                </td>
                <td>
                    <Checkbox
                        value={select}
                        onChange={() => setSelect(!select)}
                        className="checkBoxTableListProduct"
                        size="small"
                        inputProps={{'aria-label': 'checkbox with small size'}}
                    />
                </td>
                <td>{number+1}</td>
                <td>{data.name}</td>
                <td>
                    <IconButton
                        aria-label="delete"
                        onClick={() => {
                            // getAttributeById(data.id);
                            setDialogForCreate(true);
                            setDialogForEdit(true)
                        }}>
                        <EditIcon/>
                    </IconButton>
                </td>
                <td>
                    <Switch
                                className="switchTableListProduct"
                                name="checkedB"
                    />
                </td>
            </tr>
        )
    }


    useEffect(() => {
        getAllProductType();
        getAllAttribute();
    }, []);

    return (
        <Scrollbar className="ScrollDebt">
            {loading ?
                <div className="w-100 h-100">
                    <LoadingComponents/>
                </div>
                :
                <Grid item lg={11} className="m-4 w-100">
                   <div className="d-flex flex-column DivParentCreateProduct">
                       <div className="d-flex headerBoxCreateProduct">
                           <h3> 300 - </h3>
                           <h3>لیست اسلایدرها</h3>
                       </div>
                       {/*<div className="mt-4 d-flex justify-content-around parentBoxSearchListProduct">*/}
                       {/*    <div className="parentSearchInputListProduct">*/}
                       {/*        <input*/}
                       {/*            type="text"*/}
                       {/*            placeholder="عنوان جستجو"*/}
                       {/*            value={searchValue}*/}
                       {/*            onChange={(e) => setSearchValue(e.target.value)}*/}
                       {/*        />*/}
                       {/*    </div>*/}
                       {/*    <div className="parentFilterSelectListProduct">*/}
                       {/*        <Autocomplete*/}
                       {/*            value={value}*/}
                       {/*            openOnFocus={true}*/}
                       {/*            onChange={(event, newValue) => {*/}
                       {/*                setValue(newValue);*/}
                       {/*            }}*/}
                       {/*            inputValue={inputValue}*/}
                       {/*            onInputChange={(event, newInputValue) => {*/}
                       {/*                setInputValue(newInputValue);*/}
                       {/*            }}*/}
                       {/*            id="controllable-states-demo"*/}
                       {/*            options={options}*/}
                       {/*            style={{width: 300}}*/}
                       {/*            renderInput={(params) => <TextField {...params} label="فیلتر  نمایش سطر ( دسته‌بندی )"*/}
                       {/*                                                variant="outlined"/>}*/}
                       {/*        />*/}
                       {/*    </div>*/}
                       {/*</div>*/}
                       <div className="parentTableListProduct">
                           <table className="w-100">
                               <thead>
                               <tr>
                                   <th>
                                       <i className="fas fa-info-circle"/>
                                   </th>
                                   <th>
                                       <i className="far fa-square"/>
                                   </th>
                                   <th>
                                       <i className="fas fa-hashtag"/>
                                   </th>
                                   <th>
                                       عنوان
                                   </th>
                                   <th>
                                       ویرایش
                                   </th>
                                   <th>
                                       فعال/غیرفعال
                                   </th>
                               </tr>
                               </thead>
                               <tbody>
                               {allProductType !== null && allProductType.map((data, i) => (
                                   <TrTable data={data} key={i} number={i}/>
                               ))}
                               </tbody>
                           </table>
                       </div>
                       <div className="mb-4">

                       </div>
                       <div className="mt-4 footerListSlider py-3">
                           <Button
                               variant="contained"

                               className="continuationButtonCreateProduct ml-3 mr-4"
                               // disabled={allSlider !== null && allSlider.length === 0}
                               // onClick={``}
                           >
                               ثبت
                           </Button>
                           <Button
                               className="changeTypeButtonCreateProduct"
                               onClick={() => setDialogForCreate(true)}
                           >
                               ایجاد نوع محصول جدید
                           </Button>
                       </div>
                   </div>
                </Grid>
            }
            <Dialog
                open={dialogForCreate}
                onClose={() => {
                    setDialogForCreate(false);
                }}
                className="parentDialogCreateAttribute"
            >
                <div className="d-flex flex-wrap justify-content-around align-items-center my-5">
                    <Grid item lg={4} xl={4} className="parentMultiselectProductType">
                        <div className="w-100 d-flex flex-wrap justify-content-around mx-4">
                            <TextField
                                label="نام محصول"
                                variant="outlined"
                                className="w-100"
                                onChange={(e) => setProductName(e.target.value)}
                            />
                        </div>
                    </Grid>
                    <Grid item lg={6}
                          className="d-flex justify-content-around parentMultiselectProductType align-items-center w-100">
                        {allAttributes !== null &&
                        <Autocomplete
                            limitTags={3}
                            openOnFocus={true}
                            multiple
                            id="checkboxes-tags-demo"
                            options={allAttributes}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.label}
                            onChange={(event, value) => {
                                setAllAttributesSelected(value)
                                // let res = allAttributes.filter(x=>x.title === value)
                                // if(res.length === 1){
                                //     setStaticState(prevState => ({...prevState, [data.name]: res[0].value}));
                                // }
                            }}
                            renderOption={(option, {selected}) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{marginRight: 8}}
                                        checked={selected}
                                    />
                                    {option.label}
                                </React.Fragment>
                            )}
                            style={{width: 500}}
                            renderInput={(params) => (
                                <TextField {...params} variant="outlined" label="ویژگی های محصول"
                                           placeholder="انتخاب ویژگی"/>
                            )}
                        />
                        }
                    </Grid>
                    <Grid item lg={4} xl={4} className="parentMultiselectProductType mt-4">
                        <div className="w-100 d-flex flex-wrap justify-content-around mx-4">
                            <TextField
                                label="عنوان محصول(انگلیسی)"
                                variant="outlined"
                                className="w-100"
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                    </Grid>
                </div>
                <Button
                    onClick={addProductType}
                    className="continuationButtonCreateProduct w-max mb-5 mr-5"
                >
                    درج نوع محصول
                </Button>
            </Dialog>
        </Scrollbar>
    );
}

export default CreateProductType;
